module.exports = __webpack_public_path__ + "static/media/wp_support.178ddd71.png";